import { z } from 'zod';

export const chatAttachmentPresignedUploadSchema = z.object({
    attachmentId: z.string(),
    expiresAt: z.string().nullable(),
    fileName: z.string(),
    /** Null for knowledge-base references — the object is already stored, nothing to upload. */
    uploadUrl: z.string().nullable(),
});

export type ChatAttachmentPresignedUpload = z.infer<typeof chatAttachmentPresignedUploadSchema>;

export const chatAttachmentPresignResponseSchema = z.object({
    attachments: z.array(chatAttachmentPresignedUploadSchema),
});

export type ChatAttachmentPresignResponse = z.infer<typeof chatAttachmentPresignResponseSchema>;

export type ChatAttachmentUploadTarget = 'CHAT' | 'KNOWLEDGE_BASE';

export const chatAttachmentSummarySchema = z.object({
    attachmentId: z.string(),
    fileName: z.string(),
});

export type ChatAttachmentSummary = z.infer<typeof chatAttachmentSummarySchema>;

export const chatAttachmentListResponseSchema = z.object({
    attachments: z.array(chatAttachmentSummarySchema),
});

export type ChatAttachmentListResponse = z.infer<typeof chatAttachmentListResponseSchema>;

export const chatAttachmentDownloadResponseSchema = z.object({
    url: z.string(),
});

export type ChatAttachmentDownloadResponse = z.infer<typeof chatAttachmentDownloadResponseSchema>;

export const chatAttachmentOptionsSchema = z.object({
    canUpload: z.boolean(),
    canUploadToKnowledgeBase: z.boolean(),
    maxAttachments: z.number(),
    sizeLimitBytes: z.number(),
});

export type ChatAttachmentOptions = z.infer<typeof chatAttachmentOptionsSchema>;
